export default "__VITE_ASSET__Bp7x5NsY__"